<div class="chart-container">
  <apx-chart
    [series]="chartOptions.series!"
    [chart]="chartOptions.chart!"
    [title]="chartOptions.title!"
    [xaxis]="chartOptions.xaxis!"
    [yaxis]="chartOptions.yaxis!"
    [tooltip]="chartOptions.tooltip!"
    [stroke]="chartOptions.stroke!"
    [markers]="chartOptions.markers!"
    [dataLabels]="chartOptions.dataLabels!"
    [colors]="chartOptions.colors!"
  >
  </apx-chart>
</div>
